module.exports = __webpack_public_path__ + "img/i-wrote-mono.8bc40978.svg";